export default __webpack_public_path__ + "static/media/LoadedTrailer.82d8c35f.svg";